import React, { useState, useEffect } from 'react';
import Header from '../components/header';
import PageMenu from '../components/pagemenu';
import { getUserData } from '../components/api';

import './reports.css';
import ComprehensiveReports from '../components/ComprehensiveReports';

function ReportsPage() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);


  useEffect(() => {
    const checkAuth = async () => {
      // Check for auth token in localStorage on component mount
      const token = localStorage.getItem('authToken');
      if (token) {
        setIsAuthenticated(true);
        
        // Fetch user data to check if admin
        try {
          const response = await getUserData();
          setIsAdmin(response.data.is_admin || false);
        } catch (error) {
          console.error('Error fetching user data:', error);
          setIsAdmin(false);
        }
      }
      setLoading(false);
    };

    checkAuth();
  }, []);


  return (
    <div className="reports-page-wrapper">
      <div className="App">
        <Header isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated} />
        {loading ? (
          <div className='content'>
            <div style={{ padding: '2rem', textAlign: 'center' }}>Loading...</div>
          </div>
        ) : !isAuthenticated ? (
          <div className='content'>
            <div style={{ padding: '2rem', textAlign: 'center' }}>Please log in to view content</div>
          </div>
        ) : (
          <div className='content'>
            <ComprehensiveReports isAdmin={isAdmin} />
          </div>
        )}
        {/* Bottom navigation for mobile */}
        <PageMenu className="bottom-nav" />
      </div>
    </div>
  );
}

export default ReportsPage;